import moment from 'moment';
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { CurrencyInput } from 'components/ui/Inputs';
import ValidationForm from 'components/ui/ValidationForm';

import SplitPayment from '../../SplitPayment';
import { handlePaymentSubmit } from '../../SplitPayment/SplitPayment.utils';
import { Errors } from '../../SplitPayment/SplitPayment.styles';

const StandardPayment = ({
  totalPriceToBePaid,
  onAmountChange,
  currentAmount,
  isOnHold,
  title,
  payAndConfirm,
  takeDeposit,
  addPayment,
  reference,
  currency,
  method,
  loading,
  isPutOnHoldWithDeposit
}) => (
  <ValidationForm
    fields={{ amount: currentAmount }}
    validators={{
      amount: (values) => {
        const amount = Number(values.amount);

        return amount !== 0 && amount <= totalPriceToBePaid;
      }
    }}
    overrideFields={{ amount: currentAmount }}
    validateInitialFields
  >
    {({ fields, onChange, invalidInputs, hasInvalidInputs }) => {
      const handleSubmit = (e) => {
        e.preventDefault();

        handlePaymentSubmit({
          cashTendered: fields.amount,
          totalPriceToBePaid,
          payAndConfirm,
          takeDeposit,
          addPayment,
          isOnHold,
          bookingReference: reference,
          reference: `${reference}-${moment().utcOffset(0).format('YYYYMMDDHHmmssSS')}`,
          currency,
          method
        });
      };

      const handleChange = (e) => {
        onChange(e);

        if (onAmountChange) {
          onAmountChange(e.target.value);
        }
      };

      return (
        <SplitPayment
          title={title}
          subTitle={<FormattedMessage id="payments.canBeSplit" />}
          label={<FormattedMessage id="payments.recordPayment" />}
          loading={loading}
          disabled={hasInvalidInputs}
          onSubmit={handleSubmit}
        >
          <CurrencyInput
            name="amount"
            value={fields.amount}
            currency={currency}
            disabled={isPutOnHoldWithDeposit ? false : isOnHold}
            onChange={handleChange}
          />
          <Errors>
            {invalidInputs.amount && Number(fields.amount) === 0 && <FormattedMessage id="payments.amountZero" />}
            {invalidInputs.amount && Number(fields.amount) !== 0 && <FormattedMessage id="payments.amountTooLarge" />}
          </Errors>
        </SplitPayment>
      );
    }}
  </ValidationForm>
);

StandardPayment.propTypes = {
  title: PropTypes.node,
  currentAmount: PropTypes.string,
  onAmountChange: PropTypes.func,
  totalPriceToBePaid: PropTypes.number,
  loading: PropTypes.bool,
  isOnHold: PropTypes.bool,
  payAndConfirm: PropTypes.func,
  takeDeposit: PropTypes.func,
  addPayment: PropTypes.func,
  reference: PropTypes.string,
  currency: PropTypes.string,
  method: PropTypes.string,
  isPutOnHoldWithDeposit: PropTypes.bool
};

export default StandardPayment;
